import React, { useEffect, useState } from 'react';
import CheckboxTree from './CheckboxTree';
import IconButton from '@mui/material/IconButton';
import AddBoxIcon from '@mui/icons-material/AddBox';
import Box from "@mui/material/Box";
import Tab from '@mui/material/Tab';
// import { DndProvider } from 'react-dnd';
// import { HTML5Backend } from 'react-dnd-html5-backend';
import { TabPanel, TabContext, TabList } from '@mui/lab';
import Roles from './Roles';
import Rights from './Rights';

// import { useAuth } from 'src/app/auth/AuthContext';

const treeData = {
  id: 'roles',
  name: 'Roles',
  children: [
    {
      id: 'patients',
      name: 'Patients',
      children: [
        {
          id: 'notes',
          name: 'Notes',
        },
        {
          id: 'summary',
          name: 'Summary',
        },
      ],
    },
    // ... other children
  ],
};

function Modules() {
  // const dispatch = useDispatch();
  // const contextResponse = useAuth(); // Assuming useAuth is returning the response
  const [authR, setAuthR] = useState(false);
  
  // useEffect(() => {
  //   if (contextResponse) {
  //     setAuthR(contextResponse.response);
  //     console.log("contextResponse1111",contextResponse)
  //     // Dispatch the logAuthResponse action with contextResponse
  //     dispatch(logAuthResponse(contextResponse));
  //   }
  // }, [contextResponse, dispatch]);
  const [tabValue, setTabValue] = React.useState('0'); // Ensure tabValue is a string

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="page-content">
  <TabContext value={tabValue}>
  <Box
    sx={{
      borderRadius: 2,
      overflow: 'hidden',
      backgroundColor: '#e8f5e9', // light green background
      boxShadow: '0 4px 12px rgba(56, 142, 60, 0.3)',
      mb: 2,
    }}
  >
    <TabList
      onChange={handleChange}
      aria-label="Modules tabs"
      variant="fullWidth"
      sx={{
        display: 'flex',
        backgroundColor: '#c8e6c9',
        justifyContent: 'center',
        color:"#fff"
      }}
    >
      {[
        { label: 'Rights', value: '0' },
        { label: 'Roles', value: '1' },
        { label: 'Modules', value: '2' },
      ].map((tab) => (
        <Tab
          key={tab.value}
          value={tab.value}
          label={tab.label}
          sx={{
            flex: 1,
            textTransform: 'none',
            fontSize: { xs: '14px', md: '16px' },
            py: 1.5,
            fontWeight: tabValue === tab.value ? 'bold' : '500',
            backgroundColor: tabValue === tab.value ? '#3C7F6B' : 'transparent',
            color: 'black',
            transition: 'all 0.3s ease',
            '&.Mui-selected': {
              color: '#fff', // ✅ Active tab text color
            },
            '&:hover': {
              backgroundColor: tabValue === tab.value ? '#3C7F6B' : '#a5d6a7',
            },
            borderRight: '1px solid #a5d6a7',
            '&:last-of-type': {
              borderRight: 'none',
            },
          }}
        />
      ))}
    </TabList>
  </Box>

  <Box>
    <TabPanel value="0" sx={{ p: { xs: 1, md: 2 } }}>
      <Rights />
    </TabPanel>
    <TabPanel value="1" sx={{ p: { xs: 1, md: 2 } }}>
      <Roles />
    </TabPanel>
    <TabPanel value="2" sx={{ p: { xs: 1, md: 2 } }}>
      {/* <DndProvider backend={HTML5Backend}> */}
      <CheckboxTree nodes={treeData} />
      {/* </DndProvider> */}
    </TabPanel>
  </Box>
</TabContext>

  </div>
  );
}

export default Modules;
